let resumeData = {
    "imagebaseurl":"https://rbhatia46.github.io/",
    "name": "Kyle Carter",
    "role": "Full Stack Software Engineer | Former SDE at Citi",
    "linkedinId":"https://www.linkedin.com/in/kylekcarter/",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/kylekcarter/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/KyleKCarter",
          "className":"fa fa-github"
        }
      ],
    "aboutme":"After graduating from Texas A&M University and working for a Texas consulting firm in their media operations, I started pursing a career in the tech industry. To further my technological skillset, I enrolled in the DevMountain's Full Stack Web Development Bootcamp. After completion of DevMountain's Bootcamp and working as a Teaching Assistant, Citi Group extended an offer to join their engineering department as a software developer where I have been working for the past four years. During my time at Citi, I have gained experience and knowledge in many different aspects of the development world. ",
    "education":[
      {
        "UniversityName":"DevMountain",
        "specialization":"Full Stack Web Development",
        "MonthOfPassing":"December",
        "YearOfPassing":"2019"
      },
      {
        "UniversityName":"Texas A&M University",
        "specialization":"Bachelor of Education and Human Development in Sports Management",
        "MonthOfPassing":"August",
        "YearOfPassing":"2018",
        "Achievements":"Minor in Business Administration"
      }
    ],
    "work":[
        {
        "CompanyName":"Citi",
        "specialization":"Full Stack Software Engineer",
        "MonthOfLeaving":"April 2020 - ",
        "YearOfLeaving":"June 2024",
        "Description":"Full Stack Software Engineer - Deployment Team (December 2023 - June 2024) JavaScript | Angular | Jenkins",
        "Description2":"- Oversaw deployment processes at Citi, adeptly troubleshooting and resolving issues to ensure on-time delivery of software updates to production, resulting in a measurable improvement in overall system reliability.",
        "Description3":"Android Engineer | (July 2023 - December 2023) Kotlin",
        "Description4":"- Designated for a company-wide program to cross-training engineers in new technologies.",
        "Description5":"- Enhanced Citi's Mobile app for Android by improving user experience and functionality.",
        "Description6":"- Assisted implementing a new post-login enrollment program, enabling features such as push notifications, biometrics, and PIN setup to improve user security and engagement.",
        "Description7":"Products and Offers Team Lead (August 2022 - July 2023) JavaScript | Angular",
        "Description8":"- Led development of the new Products and Offers page for Citi Bank's website.",
        "Description9":"- Managed the onboarding and integration of new development teams, guiding seamless project alignment and collaborating with cross-functional teams to optimize execution, leading to company-wide recognition for the successful launch.",
        "Description10":"Software Engineer II - Dashboard Team Lead (February 2022 - August 2022) JavaScript | Angular",
        "Description11":"- Directed the end-to-end development and ongoing maintenance of the dashboard page used by all Citi customers, ensuring a consistently reliable and user-friendly experience.",
        "Description12":"- Collaborated with engineering teams to identify and resolve performance issues, continuously enhancing the dashboard's functionality based on customer feedback.",
        "Description13":"- Orchestrated the comprehensive onboarding of new engineers and teams, providing mentorship and support to ensure seamless integration and productivity.",
        "Description14":"Software Engineer I - Dashboard Team (April 2020 - February 2022) JavaScript | Angular",
        "Description15":"- Catalyzed the collaborative development of Citi's dashboard and landing page, significantly enhancing the user experience for all online customers.",
        "Description16":"- Delivered high-quality software solutions on schedule, improving application performance and reducing bugs through effective task prioritization and timeline.",
        "Description17":"- Coordinated with cross-functional teams to ensure project alignment and timely completion, establishing the Dashboard Team as a focal point of the Citi Website.",
      },
      {
        "CompanyName":"DevMountain",
        "specialization":"Mentor",
        "MonthOfLeaving":"January 2020 - April 2020",
        "Description": "- Mentor students with web development tools such as HTML, CSS, JavaScript, React.js, Redux, Node.js, SQL, Express.js, and other tools.",
        "Description2": "- Support students in their learning by answering questions.",
        "Description3": "- Advised students with their approaches to problems and tasks they needed to solve.",
        "Description4": "- Assisted the lead instructor within the classroom and lab."
      },
      {
        "CompanyName":"DESK",
        "specialization":"Web Developer (Personal Project)",
        "MonthOfLeaving":"November",
        "YearOfLeaving":"2019",
        "Tech": "React | Redux | Passport | NodeMailer",
        "Description":"DESK is an application that integrates several different entertainment services into one, allowing users to switch between different services with ease.",
        "Description2": "- Built a full-stack web application in 2 weeks using the SERN stack. (SQL, Express, React, and Node)",
        "Description3": "- Won the best technology implemented in my class."
      },
      {
        "CompanyName":"Movie Quote Generator",
        "specialization":"Web Developer (Personal Project)",
        "MonthOfLeaving":"October",
        "YearOfLeaving":"2019",
        "Tech": "React | Express | Node",
        "Description":"My first web application, but without a database, developed at DevMountain.",
        "Description2": "- This project was developed in less than a week using React, Express, and Node.",
        "Description4": "- Other technologies used were the successful implementation of many RESTful APIs."
      },
      {
        "CompanyName":"Uplink Technologies Group",
        "specialization":"IT Support",
        "MonthOfLeaving":"April 2019 - ",
        "YearOfLeaving":"September 2019",
        "Description":"- Assisted in hardware installations in medical offices around the Dallas area.",
        "Description2":"- Performed software installations in medical offices around the Dallas area.",
        "Description3":"- Helped with the onboarding process for new computer systems.",
        "Description4":"- Assist with the installation of cable for new as well as older computers and servers.",
      },
      {
        "CompanyName":"RRG Consulting",
        "specialization":"Director of Media Relations",
        "MonthOfLeaving":"May 2018 - ",
        "YearOfLeaving":"February 2019",
        "Description":"- In charge of all media including social media accounts, website design, podcast, photo, and video editing.",
        "Description2":"- Head of the Sports division, responsible for the development and sales of all sports programs.",
        "Description3":"- Created a sales mindset by pursuing opportunities and collecting clients through events and resources.",
        "Description4":"- Improved multitasking skills, creative mindset, and gained sales experience.",
      }
    ],
    "skills":[
      {
        "skillname": "JavaScript"
      },
      {
        "skillname": "TypeScript"
      },
      {
        "skillname": "Python"
      },
      {
        "skillname":"HTML"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      },
      {
        "skillname": "Angular"
      },
      {
        "skillname":"Nodejs / Express"
      },
      {
        "skillname":"Django"
      },
      {
        "skillname":"SQL"
      },
      {
        "skillname":"Redux"
      },
      {
        "skillname":"GIT"
      }

    ],
    "portfolio":[
      {
        "name":"DESK",
        "description":"Personal Project",
        "tech": "React | Redux | Passport | NodeMailer",
        "github": "https://github.com/KyleKCarter/DES",
        "imgurl":"images/deskLanding.png"
      },
      {
        "name":"Movie Quote Generator",
        "description":"NoDB Project",
        "tech": "React | Express | Node",
        "github": "https://github.com/KyleKCarter/NoDB_project",
        "imgurl":"images/movieQuoteGenerator.png"
      },
      {
        "name":"Git Hub Repositories",
        "description":"My Repositories",
        "github": "https://github.com/KyleKCarter?tab=repositories",
        "imgurl":"images/profile_pic.png"
      }
    ]
  }
  
  export default resumeData
